module.exports = __webpack_public_path__ + "static/img/编组 5备份 8.c184e50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hz/编组 5备份 8.png
// module id = b3R0
// module chunks = 1